module.exports = "/_next/static/images/06f816336bbabc03b312ad1cb9a620ae-lock.svg";